// extracted by mini-css-extract-plugin
module.exports = {"Container":"WebcamVideo_Container__2FTdJ","Video":"WebcamVideo_Video__2sXBY","Info":"WebcamVideo_Info__1pUIY","MainCanvas":"WebcamVideo_MainCanvas__1uKxz"};